<template>
  <div class="doc-api-page">
    <div class="page-title">{{ title }}</div>
    <div class="content-body">
      <div class="list-box" v-if="menuShow">
        <el-menu
            class="el-menu-vertical-demo"
            :router="true"
            :default-active="defaultMenu"
            ref="menu">
          <Menu :menus="list"></Menu>
        </el-menu>
      </div>
      <div class="doc-content-box">
        <hll-doc :data="info"></hll-doc>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './menu'
import HllDoc from '../common/hll-doc'
import {ServerInterface} from "../../axios/ServerInterface";

export default {
  name: 'genericDoc',
  data() {
    return {
      routeObj: {
        id: this.$route.params.id, // 从路由来的指定文档类型id
        infoId: this.$route.query.id, // 指定文档id
        menuId: this.$route.query.menu
      },
      list: [],
      defaultId: '',
      title: '',
      info: '',
      initFlag: '',
      menuShow: true,
    }
  },
  components: {
    Menu,
    HllDoc
  },
  computed: {
    defaultMenu() {
      if (this.$route.query.id) {
        let temp = this.$route.path + '?menu=' + this.$route.query.menu + '&id=' + this.$route.query.id;
        return temp
      }
    }
  },
  watch: {
    '$route'(newVal, oldVal) {
      this.initFlag = false;
      if (newVal.params.id !== oldVal.params.id && newVal.query.id !== oldVal.query.id) {
        this.routeObj.id = newVal.params.id;
        this.menuTrigger();
        this.getList();
      }
      if (newVal.query.menu !== oldVal.query.menu) {
        this.routeObj.menuId = newVal.query.menu;
        this.init();
      }
      if (newVal.query.id !== oldVal.query.id) {
        this.routeObj.infoId = newVal.query.id;
        this.init();
      }
      if (newVal.query.id && oldVal.query.id) {
        this.getInfo()
      }
    },
    '$store.state.app.menuList'() {
      this.init();
    },
  },
  mounted() {
    this.init();
    this.getList();
  },
  methods: {
    init() {
      this.initFlag = true;
      this.$store.state.app.menuList.forEach(el => {
        if (el.id === Number(this.$route.query.menu)) {
          this.title = el.title;
          document.title = el.title;
        }
      });
    },
    menuTrigger() {
      this.menuShow = false;
      setTimeout(() => {
        this.menuShow = true
      }, 0);
    },
    // 获取文档列表
    getList() {

      this.info = '';
      this.$axios.get("/ajax/guidance/document/tree/list", {
        params: {
          categoryId: this.routeObj.id
        }
      }).then(res => {
        this.list = res.data.data;
        if (!this.routeObj.infoId) {
          this.defaultId = this.getDefaultId(this.list);
          this.$router.replace({
            path: `${this.$route.path}`,
            query: {
              menu: this.$route.query.menu,
              id: this.defaultId
            }
          })
        }
        if (this.initFlag && this.list.length !== 0) {
          this.getInfo()
        }
      });


    },
    getDefaultId(arr, id) {
      if (id) {
        return id;
      }
      for (let i in arr) {
        if (arr[i].child_node.length !== 0) {
          return this.getDefaultId(arr[i].child_node);
        }
        return this.getDefaultId(arr[i].child_node, arr[i].id);
      }
    },
    getInfo() {
      this.$axios.get("/ajax/guidance/document/detail", {
        params: {
          documentId: this.routeObj.infoId ? this.routeObj.infoId : this.defaultId
        }
      }).then(res => {
        let data = res.data.data;
        this.info = data.info
        if (!this.info) {
          this.$message.warning('当前文档没有内容');
        } else {
          if (data.category_id === 5) {
            let time = data.updated_at;
            this.info = this.info + "<p style='position: absolute; right: 20px; bottom: 20px'>" + time + "</p>"
          }
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.doc-api-page {
  width: 1170px;
  padding: 0 0 30px;
  margin: 0 auto;
}

.page-title {
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 18px;
  color: #212121;
  text-align: center;
  margin: 24px 0;
}

.content-body {
  position: relative;
  min-height: 500px;
  margin-top: 25px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
}

.list-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 237px;
  height: 100%;
  padding-top: 20px;
  background: #F4F5F6;
  box-sizing: border-box;
  overflow-y: auto;
}

.el-menu {
  color: #212121;
  border-right: 0;
  background-color: #F4F5F6;
}

.doc-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;
}

.updated_at_p {
  padding: 22px 25px 25px 270px;
}
</style>


// WEBPACK FOOTER //
// src/components/doc/generic-doc.vue